import ApiService from './api';

export default class QuizSessionService extends ApiService {
  
  async createQuizSession(data) {
    return this.post(`/quiz_session/`, data);
  }

}
